import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/myomers/src/app/Providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/myomers/src/components/providers/TranslationsProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/myomers/src/containers/common/ActivityDetector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/myomers/src/containers/common/SessionExtensionManager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/myomers/src/containers/footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/myomers/src/containers/header/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/myomers/src/containers/liveChat/ChatWidget.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next-runtime-env/build/provider/env-provider.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next-runtime-env/build/provider/use-env-context.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/fonts.ts\",\"import\":\"Roboto_Flex\",\"arguments\":[{\"weight\":[\"300\",\"400\",\"500\",\"700\",\"900\"],\"style\":[\"normal\"],\"subsets\":[\"latin\"],\"variable\":\"--font-roboto-flex\"}],\"variableName\":\"robotoFlex\"}");
